import { differenceInCalendarDays, format, parseISO } from 'date-fns';
import { fr } from 'date-fns/locale';
import { TODAY } from '../data/store';
import type { Creator, ExhibitionStatus } from '../types/catalog';

export const LEAVING_SOON_DAYS = 21;

export function getStatus(creator: Creator): ExhibitionStatus {
  if (differenceInCalendarDays(parseISO(creator.exhibitionStart), TODAY) > 0) return 'upcoming';
  if (differenceInCalendarDays(TODAY, parseISO(creator.exhibitionEnd)) > 0) return 'past';
  return 'current';
}

export function daysLeft(creator: Creator): number {
  return Math.max(0, differenceInCalendarDays(parseISO(creator.exhibitionEnd), TODAY));
}

export function daysUntilStart(creator: Creator): number {
  return Math.max(0, differenceInCalendarDays(parseISO(creator.exhibitionStart), TODAY));
}

export function exhibitionProgress(creator: Creator): number {
  const start = parseISO(creator.exhibitionStart);
  const total = differenceInCalendarDays(parseISO(creator.exhibitionEnd), start);
  const done = differenceInCalendarDays(TODAY, start);
  return Math.min(1, Math.max(0, done / total));
}

export function isLeavingSoon(creator: Creator): boolean {
  return getStatus(creator) === 'current' && daysLeft(creator) <= LEAVING_SOON_DAYS;
}

export function formatDate(iso: string, pattern = 'd MMMM'): string {
  return format(parseISO(iso), pattern, { locale: fr });
}

export function formatDateObject(date: Date, pattern = 'd MMMM'): string {
  return format(date, pattern, { locale: fr });
}

export function statusLabel(creator: Creator): string {
  const status = getStatus(creator);
  if (status === 'upcoming') return `Arrive le ${formatDate(creator.exhibitionStart)}`;
  if (status === 'past') return `Exposé jusqu’au ${formatDate(creator.exhibitionEnd)}`;
  const left = daysLeft(creator);
  if (left === 0) return 'Dernier jour en vitrine';
  return `Encore ${left} jour${left > 1 ? 's' : ''} en vitrine`;
}
